import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { CheckCircle } from "lucide-react";

interface SingleChoiceQuestionProps {
  options: string[];
  currentAnswer: string;
  onAnswer: (answer: string) => void;
  allowOther?: boolean;
}

const SingleChoiceQuestion = ({ options, currentAnswer, onAnswer, allowOther }: SingleChoiceQuestionProps) => {
  const [otherText, setOtherText] = useState("");

  const handleOtherSelect = () => {
    if (otherText.trim()) {
      onAnswer(`Other: ${otherText}`);
      setOtherText("");
    }
  };

  return (
    <div className="space-y-3">
      {options.map((option, index) => {
        if (option === "Other" && allowOther) {
          const isOtherSelected = typeof currentAnswer === 'string' && currentAnswer.startsWith("Other: ");
          return (
            <div key={index} className="space-y-2">
                <Button
                  variant={isOtherSelected ? "default" : "outline"}
                  className={`w-full text-left justify-start p-4 md:p-4 h-auto min-h-[48px] whitespace-normal transition-all ${
                    isOtherSelected 
                      ? "bg-blue-600 hover:bg-blue-700 text-white transform scale-[1.02]" 
                      : "hover:bg-blue-50 hover:border-blue-200"
                  }`}
                onClick={() => {
                  if (otherText.trim()) {
                    handleOtherSelect();
                  }
                }}
              >
                {isOtherSelected && <CheckCircle className="mr-2 h-4 w-4" />}
                Other (please specify)
              </Button>
              <Input
                placeholder="Please specify..."
                value={otherText}
                onChange={(e) => setOtherText(e.target.value)}
                className="ml-4"
                onKeyPress={(e) => {
                  if (e.key === 'Enter' && otherText.trim()) {
                    handleOtherSelect();
                  }
                }}
              />
            </div>
          );
        }
        
        return (
          <Button
            key={index}
            variant={currentAnswer === option ? "default" : "outline"}
            className={`w-full text-left justify-start p-4 md:p-4 h-auto min-h-[48px] whitespace-normal transition-all ${
              currentAnswer === option 
                ? "bg-blue-600 hover:bg-blue-700 text-white transform scale-[1.02]" 
                : "hover:bg-blue-50 hover:border-blue-200"
            }`}
            onClick={() => onAnswer(option)}
          >
            {currentAnswer === option && <CheckCircle className="mr-2 h-4 w-4" />}
            {option}
          </Button>
        );
      })}
    </div>
  );
};

export default SingleChoiceQuestion;